export default __webpack_public_path__ + "static/media/instagram.d8a90f05.png";